// SEO configuration for programmatic page generation

export const seoConfig = {
  cities: [
    { name: 'Accra', slug: 'accra' },
    { name: 'Kumasi', slug: 'kumasi' },
    { name: 'Tema', slug: 'tema' },
    { name: 'Takoradi', slug: 'takoradi' },
    { name: 'Cape Coast', slug: 'cape-coast' },
    { name: 'Sunyani', slug: 'sunyani' },
    { name: 'Tamale', slug: 'tamale' },
    { name: 'Koforidua', slug: 'koforidua' },
    { name: 'Sekondi', slug: 'sekondi' },
    { name: 'Ho', slug: 'ho' }
  ],

  areas: {
    accra: [
      { name: 'East Legon', slug: 'east-legon' },
      { name: 'Spintex', slug: 'spintex' },
      { name: 'Kasoa', slug: 'kasoa' },
      { name: 'Dansoman', slug: 'dansoman' },
      { name: 'Madina', slug: 'madina' },
      { name: 'Teshie', slug: 'teshie' },
      { name: 'Achimota', slug: 'achimota' },
      { name: 'Adenta', slug: 'adenta' },
      { name: 'Dome', slug: 'dome' },
      { name: 'Haatso', slug: 'haatso' },
      { name: 'Labadi', slug: 'labadi' },
      { name: 'Osu', slug: 'osu' },
      { name: 'Cantonments', slug: 'cantonments' },
      { name: 'Airport Residential', slug: 'airport-residential' },
      { name: 'Labone', slug: 'labone' }
    ],
    kumasi: [
      { name: 'Ahodwo', slug: 'ahodwo' },
      { name: 'Asokwa', slug: 'asokwa' },
      { name: 'Bantama', slug: 'bantama' },
      { name: 'Nhyiaeso', slug: 'nhyiaeso' },
      { name: 'Suame', slug: 'suame' }
    ],
    tema: [
      { name: 'Community 1', slug: 'community-1' },
      { name: 'Community 25', slug: 'community-25' },
      { name: 'Sakumono', slug: 'sakumono' },
      { name: 'Michel Camp', slug: 'michel-camp' }
    ]
  },

  propertyTypes: [
    { name: 'Apartment', slug: 'apartments', plural: 'Apartments' },
    { name: 'House', slug: 'houses', plural: 'Houses' },
    { name: 'Studio', slug: 'studios', plural: 'Studios' },
    { name: 'Mini Flat', slug: 'mini-flats', plural: 'Mini Flats' },
    { name: 'Bedsitter', slug: 'bedsitters', plural: 'Bedsitters' },
    { name: 'Mansion', slug: 'mansions', plural: 'Mansions' },
    { name: 'Bungalow', slug: 'bungalows', plural: 'Bungalows' },
    { name: 'Self Contain', slug: 'self-contains', plural: 'Self Contains' }
  ],

  bedrooms: [
    { name: 'Studio', slug: 'studio', count: 0 },
    { name: '1 Bedroom', slug: '1-bedroom', count: 1 },
    { name: '2 Bedroom', slug: '2-bedroom', count: 2 },
    { name: '3 Bedroom', slug: '3-bedroom', count: 3 },
    { name: '4 Bedroom', slug: '4-bedroom', count: 4 },
    { name: '5 Bedroom', slug: '5-bedroom', count: 5 },
    { name: '6+ Bedroom', slug: '6-bedroom', count: 6 }
  ],

  priceRanges: [
    { name: 'Cheap', slug: 'cheap', min: 0, max: 500 },
    { name: 'Affordable', slug: 'affordable', min: 500, max: 1000 },
    { name: 'Luxury', slug: 'luxury', min: 2000, max: null }
  ]
};

// Generate SEO metadata for a page
export const generateSEOMetadata = ({ city, area, propertyType, bedrooms, priceRange }) => {
  const parts = [];
  
  // Build title parts
  if (priceRange) parts.push(priceRange.name);
  if (bedrooms) parts.push(bedrooms.name);
  if (propertyType) parts.push(propertyType.plural);
  parts.push('for Rent');
  if (area) parts.push(`in ${area.name}`);
  else if (city) parts.push(`in ${city.name}`);
  
  const title = `${parts.join(' ')} | GhanaStay`;
  
  // Build description
  const descParts = [];
  descParts.push('Browse verified');
  if (priceRange) descParts.push(priceRange.name.toLowerCase());
  if (bedrooms) descParts.push(bedrooms.name.toLowerCase());
  if (propertyType) descParts.push(propertyType.plural.toLowerCase());
  descParts.push('for rent');
  if (area) descParts.push(`in ${area.name}`);
  else if (city) descParts.push(`in ${city.name}`);
  descParts.push('Ghana. Contact landlords and agents directly on GhanaStay.');
  
  const description = descParts.join(' ');
  
  // Build H1
  const h1Parts = [];
  if (priceRange) h1Parts.push(priceRange.name);
  if (bedrooms) h1Parts.push(bedrooms.name);
  if (propertyType) h1Parts.push(propertyType.plural);
  h1Parts.push('for Rent');
  if (area) h1Parts.push(`in ${area.name}`);
  else if (city) h1Parts.push(`in ${city.name}`);
  
  const h1 = h1Parts.join(' ');
  
  return { title, description, h1 };
};

// Generate URL path for SEO page
export const generateSEOPath = ({ city, area, propertyType, bedrooms, priceRange }) => {
  const parts = ['/rent'];
  
  if (propertyType) parts.push(propertyType.slug);
  if (city) parts.push(city.slug);
  if (area) parts.push(area.slug);
  if (bedrooms) parts.push(bedrooms.slug);
  if (priceRange) parts.push(priceRange.slug);
  
  return parts.join('/');
};

// Generate all possible SEO page combinations
export const generateAllSEOPages = () => {
  const pages = [];
  
  // City + Property Type pages
  seoConfig.cities.forEach(city => {
    seoConfig.propertyTypes.forEach(propertyType => {
      pages.push({
        path: generateSEOPath({ city, propertyType }),
        metadata: generateSEOMetadata({ city, propertyType }),
        filters: { city: city.slug, propertyType: propertyType.slug }
      });
      
      // City + Property Type + Bedrooms
      seoConfig.bedrooms.forEach(bedrooms => {
        pages.push({
          path: generateSEOPath({ city, propertyType, bedrooms }),
          metadata: generateSEOMetadata({ city, propertyType, bedrooms }),
          filters: { city: city.slug, propertyType: propertyType.slug, bedrooms: bedrooms.count }
        });
      });
      
      // City + Property Type + Price Range
      seoConfig.priceRanges.forEach(priceRange => {
        pages.push({
          path: generateSEOPath({ city, propertyType, priceRange }),
          metadata: generateSEOMetadata({ city, propertyType, priceRange }),
          filters: { 
            city: city.slug, 
            propertyType: propertyType.slug,
            minPrice: priceRange.min,
            maxPrice: priceRange.max
          }
        });
      });
    });
  });
  
  // Area-specific pages (for cities with defined areas)
  Object.keys(seoConfig.areas).forEach(citySlug => {
    const city = seoConfig.cities.find(c => c.slug === citySlug);
    seoConfig.areas[citySlug].forEach(area => {
      seoConfig.propertyTypes.forEach(propertyType => {
        pages.push({
          path: generateSEOPath({ city, area, propertyType }),
          metadata: generateSEOMetadata({ city, area, propertyType }),
          filters: { city: citySlug, area: area.slug, propertyType: propertyType.slug }
        });
        
        // Area + Property Type + Bedrooms
        seoConfig.bedrooms.forEach(bedrooms => {
          pages.push({
            path: generateSEOPath({ city, area, propertyType, bedrooms }),
            metadata: generateSEOMetadata({ city, area, propertyType, bedrooms }),
            filters: { 
              city: citySlug, 
              area: area.slug, 
              propertyType: propertyType.slug, 
              bedrooms: bedrooms.count 
            }
          });
        });
      });
    });
  });
  
  return pages;
};

export default seoConfig;
